import { Box, Stack } from "@similarweb/ui-components/foundations";

import { LoadingView } from "app/pages/sales-intelligence/modules/ai-agent/components/LoadingView/LoadingView";
import LoaderGradient, {
    LOADER_GREY_GRADIENT_ID,
} from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Loader/LoaderGradient";

type AIAgentEmailRefinePanelLoaderProps = {
    isLoading: boolean;
    isUpdatingVersion: boolean;
};

export const AIAgentEmailRefinePanelLoader = ({ isUpdatingVersion, isLoading }: AIAgentEmailRefinePanelLoaderProps) => {
    if (isUpdatingVersion) {
        return (
            <Stack
                justifyContent="space-between"
                flex="1"
            >
                <Stack gap="12px">
                    <Box width="100%">
                        <LoaderGradient
                            height={148}
                            id={LOADER_GREY_GRADIENT_ID}
                        />
                    </Box>
                    <Box width="100%">
                        <LoaderGradient
                            height={148}
                            id={LOADER_GREY_GRADIENT_ID}
                        />
                    </Box>
                </Stack>
                <Box>
                    <LoaderGradient
                        height={36}
                        id={LOADER_GREY_GRADIENT_ID}
                    />
                </Box>
            </Stack>
        );
    }

    if (isLoading) {
        return (
            <Box width="100%">
                <LoadingView />
            </Box>
        );
    }
};
